import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que dejar de comer comida latina?',
    a: 'No, aprenderás a sustituir los ingredientes inflamatorios (como el aceite de canola) por opciones ancestrales que no te hinchan.'
  }, {
    q: '¿Es seguro si tengo presión alta?',
    a: 'El protocolo usa sales minerales de alta calidad, pero siempre recomendamos mostrar la receta a tu médico de cabecera.'
  }, {
    q: '¿Voy a pasar hambre?',
    a: 'Absolutamente no. Este plan se enfoca en nutrición densa, no en restricción calórica.'
  }, {
    q: '¿Necesito comprar equipos caros?',
    a: 'Solo necesitas agua filtrada, limones y sal de calidad (Rosa o Celta).'
  }, {
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'La mayoría de los usuarios reporta ligereza en las articulaciones después de las primeras 48 a 72 horas.'
  }, {
    q: '¿Es un pago único?',
    a: 'Sí, pagas una vez y el manual es tuyo para siempre.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 bg-sand/20" data-id="element-78">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-79">
        <FadeIn data-id="element-80">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-forest mb-12" data-id="element-81">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={0.1 * idx} data-id="element-83">
              <div className="bg-white rounded-2xl shadow-sm border border-sand overflow-hidden transition-all duration-300" data-id="element-84">
                <button onClick={() => toggleFaq(idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-85">
                  <span className="font-bold text-forest pr-4" data-id="element-86">{faq.q}</span>
                  {openIndex === idx ? <ChevronUp className="w-5 h-5 text-emerald flex-shrink-0" data-id="element-87" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-88" />}
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-89">
                  <p className="text-gray-600 text-sm leading-relaxed border-t border-sand/50 pt-4" data-id="element-90">
                    {faq.a}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}